import { IdRef } from './core';

export enum JobStatus {
  Requested = 'requested',
  Scheduled = 'scheduled',
  Reschedule = 'reschedule_requested',
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'in_progress',
}

export enum BundleStatus {
  Draft = 'draft',
  Offered = 'offered',
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
}

export enum BundleOfferStatus {
  Pending = 'pending',
  Offered = 'offered',
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
  Unavailable = 'unavailable',
}

export enum JobsFilterType {
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  GoAnytime = 'Go Anytime',
}

export interface Job {
  id: IdRef
  orderId: IdRef
  reportIds: string[] | null
  status: JobStatus
  scheduledTime: number
  inspectionIds: IdRef[]
  isFee: boolean
  isGoAnytime: boolean
  isMock: boolean
}

export interface JobInterface {
  [id: IdRef]: Job;
}

export interface BundleInspection {
  id: string
  inspectionId: string
  appointmentAvailabilities?: number[]
}

export interface Bundle {
  id: string
  status: BundleStatus
  requestedAt: number
  bundleInspections: BundleInspection[]
}

export interface BundleOffer {
  id: string
  status: BundleOfferStatus
  totalPay: number
  inspectionIds: IdRef[]
  bundle: Bundle
}

export interface BundleOffersInterface {
  [bundleOfferId: string]: BundleOffer
}
